import { useRouter } from 'next/router';
import { useState } from 'react';
import { useRouterChangeStart } from '../../../Utils/customHooks';
import { getPriceParams } from '../../../Utils/productPageUtils';
import { customStyles } from '../../../Utils/redirections';
import { NewTrustStripSection } from './styled';
import TrustTypeMerge from './TrustTypeMerge';

import dynamic from 'next/dynamic';
import TrustTypeNonReturn from './TrustTypeNonReturn';
import { fireEvent } from '../../../Utils/fireEvent';

const Modal = dynamic(() => import('react-modal'), {
  ssr: false,
});
const TrustModal = dynamic(() => import('./TrustModal'), {
  ssr: false,
});

export default function NewTrustStrip(props) {
  const { productData } = props;
  const [openTrustPopup, setOpenTrustPopup] = useState(false);
  const [ref, setRef] = useState(null);
  const Styles = customStyles('', '', '0', '');
  const router = useRouter();

  const trustPolicies = [
    {
      trustHead: '15 Days Easy Returns Policy',
      trustBody:
        "No questions asked return policy. Return your products within 15 days of order delivery. No need to call customer care for returns, just go to My Orders and click on 'Return Item'. ",
    },
    {
      trustHead: 'Same Day Refund',
      trustBody:
        'If you cancel or return the product, your refund will be credited to your account on the same day of return approval. Most refunds are processed instantly, but in some cases the bank may take upto 24 hours. If you face any issues in your refund, we are available for you at',
    },
    {
      trustHead: 'FREE Delivery',
      trustBody:
        'FREE Delivery is eligible for all products with minimum order value of ₹299.',
    },
    {
      trustHead: '100% Secure Payments',
      trustBody:
        'Razorpay integrated highly secured payment methods-accepting UPI, mobile wallets, Domestic & International Credit & Debit cards, EMIs ( Credit/Debit Cards & Cardless), Netbanking from 58 banks & hassle free Cash on Delivery.',
    },
  ];
  const handleEasyReturnPopup = (url, shallow) => {
    if (url.includes('truststrip')) {
      setOpenTrustPopup(true);
    } else {
      setOpenTrustPopup(false);
    }
  };
  const closeModal = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('truststrip');
    if (window?.history?.length > 2) {
      router.back();
    } else {
      router.replace(
        window.location.pathname.toString() + '?' + params,
        undefined,
        { scroll: false },
      );
    }
    ref.current.style.opacity = 1;
  };
  useRouterChangeStart(handleEasyReturnPopup);

  const fireEventHandler = () => {
    const { pricingParam, conversionParam } = getPriceParams(productData);
    fireEvent({
      category: 'clicked_section_in_pdp',
      id: productData?.id,
      sku_name: productData?.name,
      selling_price: productData?.price,
      screen_name: 'PDP',
      pricing_param: pricingParam,
      conversion_param: conversionParam,
      trust_tag: productData?.signal?.name || '',
      section_name: 'trustfactor_banner_new',
    });
  };

  const trustStripClickHandler = (trustRef) => {
    trustRef.current.style.opacity = 0.4;
    setRef(trustRef);
    setTimeout(() => {
      fireEventHandler();
      const params = new URLSearchParams(window.location.search);
      params.set('truststrip', 'true');
      router.push(`${window.location.pathname}/?${params}`, undefined, {
        shallow: true,
        scroll: false,
      });
    }, 50);
  };
  const modalProps = { closeModal, trustPolicies };
  return (
    <>
      {productData?.returnable ? (
        <NewTrustStripSection>
          <TrustTypeMerge
            trustStripClickHandler={trustStripClickHandler}
            fireEventHandler={fireEventHandler}
            policyData={productData?.policyData}
          />
        </NewTrustStripSection>
      ) : (
        <NewTrustStripSection>
          <TrustTypeNonReturn productId={productData?.id} />
        </NewTrustStripSection>
      )}

      {openTrustPopup && (
        <Modal
          isOpen={openTrustPopup}
          onRequestClose={closeModal}
          style={Styles}
        >
          <TrustModal {...modalProps} />
        </Modal>
      )}
    </>
  );
}
